import Big from 'big.js';

Big.DP = 2;
Big.RM = Big.roundHalfUp;

export default Big;
